import Cookies from 'js-cookie';

export const refreshRecipes = (forceRefresh = false) => {

    // Check if session data exists
    const recipeList = sessionStorage.getItem('recipeList');
    const recipeDetails = sessionStorage.getItem('recipes');

    const recipesInit = { recipes: {} };

    const api = `${process.env.REACT_APP_BACKEND_ADDRESS}/recipes`;

    const headers = { 'Authorization': 'Bearer ' + Cookies.get('token'), 'content-type': 'application/json' };

    let requestOptions = {
        method: 'GET',
        headers: headers,
    };

    async function fetchApi() {
        try {
            const data = await fetch(api, requestOptions);
            const response = await data.json();
            sessionStorage.setItem('recipeList', JSON.stringify(response));
        } catch (error) {
            // handle error
            console.log(error);
        }
    }

    if (forceRefresh || !recipeList) {
        // Data does not exist or force refresh is requested
        fetchApi();
        console.log('Refreshing recipe data');
    }

    if (!recipeDetails) {
        sessionStorage.setItem('recipes', JSON.stringify(recipesInit));
    }

};
